import { ApiHealth } from '../hooks/useApiHealth';

interface SidebarStatusProps {
  health: ApiHealth;
}

function formatTime(date: Date | null): string {
  if (!date) return '—';
  return date.toLocaleTimeString('en-US', { hour12: false });
}

export function SidebarStatus({ health }: SidebarStatusProps) {
  const { status, latencyMs, lastSyncAt } = health;
  const statusLabel = status === 'connected' ? 'CONNECTED' : status === 'connecting' ? 'CONNECTING' : 'OFFLINE';
  const statusColorClass =
    status === 'connected'
      ? 'text-success'
      : status === 'connecting'
      ? 'text-text-3'
      : 'text-danger';
  const dotColorClass =
    status === 'connected'
      ? 'bg-success shadow-[0_0_6px_rgb(var(--color-success))]'
      : status === 'connecting'
      ? 'bg-text-3'
      : 'bg-danger shadow-[0_0_6px_rgb(var(--color-danger))]';

  return (
    <div className="border-t border-border px-4 py-2.5 font-mono text-[10px] text-text-3 flex flex-col gap-[3px]">
      <div className="flex justify-between">
        <span className="flex items-center">
          <span
            className={`inline-block w-1.5 h-1.5 rounded-full mr-1.5 align-middle animate-pulse ${dotColorClass}`}
          />
          API
        </span>
        <span className={`font-semibold ${statusColorClass}`}>{statusLabel}</span>
      </div>
      <div className="flex justify-between">
        <span>LATENCY</span>
        <span>{latencyMs == null ? '—' : `${latencyMs}ms`}</span>
      </div>
      <div className="flex justify-between">
        <span>SYNC</span>
        <span>{formatTime(lastSyncAt)}</span>
      </div>
    </div>
  );
}
